import { render, staticRenderFns } from "./ExcelView.vue?vue&type=template&id=5d22813a&scoped=true&"
import script from "./ExcelView.vue?vue&type=script&lang=js&"
export * from "./ExcelView.vue?vue&type=script&lang=js&"
import style0 from "./ExcelView.vue?vue&type=style&index=0&id=5d22813a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d22813a",
  null
  
)

export default component.exports